import React, { useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { api, superAdminReqConfig } from "../../include/api";
import { formateDate } from "../../include/function";
import Error from "../add-ons/Error";
import Spinner from "../add-ons/Spinner";
import SuperAdminHeader from "./Header";
import { useNotification } from "../../Toast/ToastProvider"

const SuperAdminVoucher = () => {
    const [fetchLoading, setFetchLoading] = useState(true);
    const [vouchers, setVouchers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const toast = useNotification()
        const [saving, setSaving] = useState(false)
    const SUCCESS = "success";
    const ERROR = "error";

    // Fetch vouchers from the API
    const getVouchers = (afterGet) => {
        setFetchLoading(true);
        api.get('/voucher/', superAdminReqConfig())
            .then(response => {
                if (response.status === 200) {
                    setVouchers(response.data.data);
                    if (afterGet) afterGet(response.data.data);
                }
            })
            .catch(() => {
                setVouchers([]);
                if (afterGet) afterGet([]);
            })
            .finally(() => setFetchLoading(false));
    };

    // Delete a voucher by ID
    const deleteVoucher = (id) => {
            if (window.confirm("Are you sure you want to delete this voucher?")) {
                setSaving(true);
                api.delete('/voucher/?id=' + id, superAdminReqConfig())
                    .then(response => {
                        if (response.status === 200) {
                            toast({ type: SUCCESS, message: response.data.message });
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            toast({ type: ERROR, message: error.response.data.message });
                        } else {
                            toast({ type: ERROR, message: error.message });
                        }
                    })
                .finally(() => {
                    setSaving(false);
                    getVouchers();
                });
                    }
    };

    useEffect(() => {
        getVouchers();
    }, []);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredVouchers = vouchers.filter(voucher =>
        voucher.code.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <SuperAdminHeader>
            <div className="fixed-top-bar">
                <div className="container my-3">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                        <h5 className="m-0">Voucher</h5>
                        <Link to="/super/add-voucher" className="btn btn-success">Add new voucher</Link>
                    </div>
                    <div className="py-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search vouchers..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </div>
                    {fetchLoading ? (
                        <Spinner color="danger" spinnerSize="lg" />
                    ) : filteredVouchers.length > 0 ? (
                        <div className="row">
                            {filteredVouchers.map((voucher) => (
                                <Voucher
                                    voucher={voucher}
                                    key={voucher.id}
                                    onDelete={deleteVoucher}
                                />
                            ))}
                        </div>
                    ) : (
                        <Error
                            mainText="No voucher found!"
                            secondaryText={<Link to="/super/add-voucher">Add New voucher</Link>}
                        />
                    )}
                </div>
            </div>
        </SuperAdminHeader>
    );
};

const Voucher = ({ voucher, onDelete }) => {
    return (
        <div className="col-12 col-md-6 col-lg-4 col-xl-3 p-2">
            <div className="border shadow-sm p-2">
                <h6 className="d-flex align-items-center justify-content-between fw-bold">
                    <div className="text-truncate">
                        <i
                            className={`fas fa-circle blink ${
                                voucher.status === "active" ? "text-success" : "text-danger"
                            }`}
                            style={{ fontSize: ".7rem" }}
                        />
                        <span className="ps-2">{voucher.code}</span>
                    </div>
                    <Link
                        to={`/super/edit-voucher/${voucher.id}`}
                        className="small d-flex align-items-center hover-underline"
                    >
                        Edit
                        <i className="fas fa-pencil-alt fa-sm ps-2" />
                    </Link>
                    <button
                        className="btn btn-link p-0 ms-2"
                        onClick={() => onDelete(voucher.id)}
                    >
                        <i className="fas fa-trash-alt fa-sm text-danger" />
                    </button>
                </h6>
                <hr className="my-2" />
                <p className="small mb-1 text-muted d-flex align-items-center">
                    <i className="fas fa-stopwatch-20 fa-md fa-fw text-primary" />
                    <span className="ps-2 text-truncate">
                        {voucher.currentCount} / {voucher.maxCount}
                    </span>
                </p>
                <p className="small mb-1 text-muted d-flex align-items-center">
                    <i className="fas fa-tags fa-md fa-fw text-primary" />
                    <span className="ps-2 text-truncate">{voucher.text}</span>
                </p>
                <p className="small mb-1 text-muted d-flex align-items-center">
                    <i className="fas fa-clock fa-md fa-fw text-primary" />
                    <span className="ps-2 text-truncate">{formateDate(voucher.validity)}</span>
                </p>
            </div>
        </div>
    );
};

export default SuperAdminVoucher;